export enum OrderStatus {
  /**
   * Order was entered, but no shipments have been created
   */
  PENDING = 'PENDING',

  /**
   * One or more shipments have been planned to execute this order.
   * (In this context, "planned" means we have assigned a carrier, but not necessarily tendered to that carrier)
   */
  IN_PROCESS = 'IN_PROCESS',

  /**
   * One or more related ship orders have been picked up
   */
  SHIPPED = 'SHIPPED',

  /**
   * All related ship orders have been delivered
   */
  DELIVERED = 'DELIVERED',

  /**
   * One or more carrier invoices are awaiting customer approval
   */
  CUSTOMER_REVIEW = 'CUSTOMER_REVIEW',

  /**
   * All related shipments have been invoiced
   */
  BILLED = 'BILLED',

  /**
   * All related invoices have been paid
   */
  COMPLETE = 'COMPLETE',

  /**
   * Order was canceled
   */
  CANCELED = 'CANCELED',
}
